import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./LeasingItemFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";
import LeasingFormStepOne from "./LeasingFormSteps/LeasingItemFormStepOne";
import LeasingItemFormStepOne from "./LeasingFormSteps/LeasingItemFormStepOne";

const LeasingItemForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      const initialLeasingItem = _initialValues?.car
        ? { value: _initialValues.car.uuid, label: _initialValues.car.vin }
        : _initialValues?.device
        ? {
            value: _initialValues.device.uuid,
            label: _initialValues.device.serialNumber,
          }
        : null;
      setInitialValues({
        ..._initialValues,
        leasingType: _initialValues?.leasingType?.uuid
          ? { value: _initialValues?.leasingType?.uuid }
          : null,
        leasingItem: initialLeasingItem,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="LeasingForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <LeasingItemFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default LeasingItemForm;
